import React, { useEffect, useState } from 'react';
import {
  Table,
  Layout,
  Row,
  Col,
  Card,
  Button,
  Typography,
  Select,
  ConfigProvider,
  List,
  Switch,
} from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import {
  getUsers,
  getCourseStatics,
  getAssessmentStatics,
  getDepartments,
  createInitialProgress,
  getTrainingAssessment,
  updatePublishScore,
  updateReattempt,
  updateSubmission,
} from '../../services/ApiActions/adminAct';
import Loader from '../../components/Layout/Loader';

const { Content } = Layout;
const { Text, Title } = Typography;

const TrainingAssessmentPage = () => {
  const navigate = useNavigate();
  const [assessments, setAssessments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(true);
  const [defaultDepartmentOption, setDefaultDepartmentOption] = useState<
    string | undefined
  >();
  const [departmentOptions, setDepartmentOptions] = useState([]);
  
  const fetchUpdatedAssessments = async () => {
    try {
      setIsUpdating(true);
      const response: any = await getTrainingAssessment(
        defaultDepartmentOption
      );
      setAssessments(response.data);
      setIsUpdating(false);
    } catch (error) {
      setIsUpdating(false);
    }
  };
  useEffect(() => {
    
    const fetchAssessments = async () => {
      try {
        setIsUserLoading(true);
        const response: any = await getTrainingAssessment(
          defaultDepartmentOption
        );
        setAssessments(response.data);
        setIsUserLoading(false);
      } catch (error) {
        setIsUserLoading(false);
      }
    };
    fetchAssessments();
  }, [defaultDepartmentOption]);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response: any = await getDepartments();
        const deptOptions = response.data.map((department: any) => ({
          label: department.attributes.name,
          value: department.attributes.name,
        }));
        deptOptions.unshift({ label: 'All', value: '' });
        setDepartmentOptions(deptOptions);
      } catch (error) {
        console.error('Error fetching departments:', error);
      }
    };

    fetchDepartments();
  }, []);

  const handleDepartmentChange = (department: string) => {
    setDefaultDepartmentOption(department);
  };
  const togglePublishScore = async (id: number, value: boolean) => {
    try {
      setIsUpdating(true);
      await updatePublishScore({
        id: id,
        publish_score: value,
      });
      
      setAssessments((prevData: any) =>
        prevData.map((item: any) =>
          item.id === id ? { ...item, publish_score: value } : item
        )
      );
    } catch (error) {
      console.log(error);
    } finally {
      setIsUpdating(false);
    }
  };
  const toggleReattempt = async (id: number, value: boolean) => {
    try {
      console.log('value --', value);
      setIsUpdating(true);
      await updateReattempt({ id: id, reattempt_enabled: value });
      fetchUpdatedAssessments()
      // setAssessments((prevData: any) =>
      //   prevData.map((item: any) =>
      //     item.id === id ? { ...item, reattempt_enabled: value, ...(value === true && {publish_score: false}) } : item
      //   )
      // );
    } catch (error) {
      console.log(error);
    } finally {
      setIsUpdating(false);
    }
  };
  const toggleSubmission = async (id: number, value: boolean) => {
    try {
      setIsUpdating(true);
      await updateSubmission({ id: id, enable_submission: value });
      fetchUpdatedAssessments();
    } catch (error) {
      console.log(error);
    } finally {
      setIsUpdating(false);
    }
  };
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Publish Score ',
      dataIndex: 'id',
      key: 'publist-score',
      render: (_: any, record: any) => {
        const { id, publish_score } = record;
        return (
          <Switch
            checked={publish_score}
            onChange={() => togglePublishScore(id, !publish_score)}
          />
        );
      },
    },
    {
      title: 'Enable Reattempt',
      dataIndex: 'id',
      key: 'enable-reattempt',
      render: (_: any, record: any) => {
        const { id, reattempt_enabled } = record;
        return (
          <Switch
            checked={reattempt_enabled}
            onChange={() => toggleReattempt(id, !reattempt_enabled)}
          />
        );
      },
    },
    {
      title: 'Enable Submission',
      dataIndex: 'id',
      key: 'enable-submission',
      render: (_: any, record: any) => {
        const { id, enable_submission } = record;
        return (
          <Switch
            checked={enable_submission}
            onChange={() => toggleSubmission(id, !enable_submission)}
          />
        );
      },
    },
    {
      title: 'Users',
      dataIndex: 'id',
      key: 'id',
      render: (id: any) => (
        <Link
          to={`/admin-training-assessment-users/${id}`}
          style={{ display: 'flex' }}
        >
          <span>View Users &nbsp;</span>
          <ArrowTopRightOnSquareIcon className="custom-icon hero-icon-18" />
        </Link>
      ),
    },

    /*{
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
    },
    {
      title: 'Course Completed',
      dataIndex: 'course_data',
      key: 'course_data',
      render: (course_data: {
        complete_course: number;
        total_course: number;
      }) => (
        <span
          style={{
            background: '#F0E2D5',
            padding: '5px 8px',
            borderRadius: '15px',
          }}
        >
          {course_data.complete_course}/{course_data.total_course}
        </span>
      ),
    },*/
  ];
  if (isUserLoading) {
    return <Loader style={{ marginTop: '20%', justifyContent: 'center' }} />;
  }
  return (
    <Layout style={{ padding: '10px 0' }}>
      <Content>
        <Row>
          <Col style={{ textAlign: 'right', marginBottom: '12px' }} span={24}>
            <Button href={'/admin'}>Back</Button>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginTop: '24px' }}>
          <Col span={24}>
            <Card>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Title level={3} style={{ margin: '0 0 0 5px', flexGrow: 1 }}>
                  Assessment
                </Title>
                <Select
                  placeholder="Filter by Department"
                  defaultValue={defaultDepartmentOption}
                  onChange={handleDepartmentChange}
                  options={departmentOptions}
                  style={{ minWidth: '200px' }}
                />
              </div>
              {isUserLoading ? (
                <Loader
                  style={{ marginTop: '20%', justifyContent: 'center' }}
                />
              ) : (
                <ConfigProvider
                  theme={{
                    components: {
                      Table: {
                        cellFontSize: 16,
                      },
                    },
                  }}
                >
                  <Table
                    className="custom-table users-list"
                    bordered={false}
                    columns={columns}
                    dataSource={assessments}
                    loading={isUpdating}
                  />
                </ConfigProvider>
              )}
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default TrainingAssessmentPage;
